export default function EFXGanPower(props: any) {
    return (
        <svg width="167" height="27" viewBox="0 0 167 27" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_2638_23723)">
                <path d="M64.6667 8.07031H62.4407L55.7168 16.6027H58.6879L62.7757 11.4153L64.0841 16.6027H66.8198L64.6667 8.07031Z" fill="currentColor" />
                <path
                    d="M47.7569 4.08446C45.3441 4.08446 42.8657 6.04095 42.2176 8.45137L41.2029 12.2406C40.5572 14.6534 41.987 16.6075 44.3998 16.6075H54.0706L56.0951 9.0558H53.5608L52.2355 13.998H45.2081C44.1352 13.998 43.4992 13.129 43.7881 12.0561L44.7057 8.63343C44.9921 7.56051 46.0941 6.6915 47.167 6.6915H56.7286L57.4277 4.08203H47.7569V4.08446Z"
                    fill="currentColor"
                />
                <path
                    d="M83.219 4.08447L80.8474 12.9421L74.4658 4.08447H74.4075H71.798L68.4434 16.6099H71.0504L73.4244 7.75472L79.8036 16.6099H80.6775H82.4714L85.8285 4.08447H83.219Z"
                    fill="currentColor"
                />
                <path d="M31.8184 11.6508H38.8263L39.5254 9.04614H32.5199L31.8208 11.6508H31.8184Z" fill="currentColor" />
                <path d="M17.0916 0.698242H10.0254L16.1983 9.04854L20.7036 5.58219L17.0916 0.698242Z" fill="currentColor" />
                <path d="M24.2935 19.9986H31.3597L25.6965 12.3376L20.8223 15.3064L24.291 19.9986H24.2935Z" fill="currentColor" />
                <path
                    d="M37.8312 0.698242H28.9542L13.6056 12.4736H16.9676L0 26.6982L29.0634 9.04611H25.6772L37.8312 0.698242Z"
                    fill="url(#paint0_linear_2638_23723)"
                />
                <path
                    d="M115.314 4.08447H107.1C105.491 4.08447 103.838 5.38799 103.408 6.99737L101.612 13.6994C101.18 15.3088 102.136 16.6123 103.743 16.6123H111.957C113.567 16.6123 115.22 15.3088 115.649 13.6994L117.446 6.99737C117.878 5.38799 116.921 4.08447 115.314 4.08447ZM113.166 13.515C113.093 13.782 112.819 14.0004 112.55 14.0004H104.551C104.284 14.0004 104.124 13.782 104.197 13.515L105.894 7.17942C105.966 6.91241 106.241 6.69394 106.51 6.69394H114.508C114.775 6.69394 114.936 6.91241 114.863 7.17942L113.166 13.515Z"
                    fill="currentColor"
                />
                <path
                    d="M160.886 11.6629H162.972C164.312 11.6629 165.69 10.5754 166.05 9.23545L166.778 6.51432C167.137 5.17439 166.341 4.08691 165.001 4.08691H153.359L152.66 6.69395H164.163L163.53 9.05582H152.026L150.002 16.6124H152.541L153.866 11.6629H157.19L160.811 16.6124H164.506L160.884 11.6629H160.886Z"
                    fill="currentColor"
                />
                <path
                    d="M130.085 14.0781H126.459L129.136 4.08447H126.604L123.927 14.0781H120.3L122.978 4.08447H120.371L117.014 16.6099H129.585C130.925 16.6099 132.304 15.5224 132.663 14.1825L135.37 4.08447H132.763L130.085 14.0781Z"
                    fill="currentColor"
                />
                <path
                    d="M99.9443 4.08447H88.3024L87.6033 6.69151H99.1068L98.8568 7.62364L98.4733 9.05338H86.9698L84.9453 16.6099H87.4844L88.8097 11.6604H97.9125C99.2525 11.6604 100.631 10.5729 100.991 9.23301L101.719 6.51188C102.078 5.17195 101.282 4.08447 99.9419 4.08447H99.9443Z"
                    fill="currentColor"
                />
                <path d="M134.156 16.61H148.184L148.881 14.0102H137.392L138.023 11.6508H149.514L150.211 9.04614H136.183L134.156 16.61Z" fill="currentColor" />
                <path d="M136.816 6.68666H150.844L151.541 4.08447H137.513L136.816 6.68666Z" fill="currentColor" />
            </g>
            <defs>
                <linearGradient id="paint0_linear_2638_23723" x1="34.3212" y1="-0.588286" x2="-0.890858" y2="30.1791" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E7BE2D" />
                    <stop offset="1" stopColor="#A67517" />
                </linearGradient>
                <clipPath id="clip0_2638_23723">
                    <rect width="166.863" height="26" fill="white" transform="translate(0 0.698242)" />
                </clipPath>
            </defs>
        </svg>
    );
}
